import { NavItem } from './nav-item/nav-item';
import { UserRole } from '@core/constants/roles.constants';

export const navItems: NavItem[] = [
  { navCap: 'INICIO' },
  {
    displayName: 'Dashboard',
    iconName: 'solar:atom-line-duotone',
    route: '/dashboard',
  },
  { navCap: 'ADMINISTRACIÓN' },
  // Estos 3 SÍ usan roles porque no tienen permiso granular
  {
    displayName: 'Roles',
    iconName: 'solar:shield-user-line-duotone',
    route: '/administracion/roles',
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.TRABAJADOR, UserRole.SUPERVISOR_DIRECTO],
  },
  {
    displayName: 'Usuarios',
    iconName: 'solar:users-group-rounded-line-duotone',
    route: '/administracion/usuarios',
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.TRABAJADOR],
  },
  {
    displayName: 'Permisos',
    iconName: 'solar:lock-keyhole-line-duotone',
    route: '/administracion/permisos',
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.TRABAJADOR],
  },
  {
    displayName: 'Permisos Globales',
    iconName: 'solar:global-line-duotone',
    route: '/administracion/permisos-globales',
    roles: [UserRole.SUPER_ADMIN],
  },
  { navCap: 'MÓDULOS' },
  {
    displayName: 'Core HCM',
    iconName: 'solar:widget-2-line-duotone',
    permiso: 'CORE_HCM',
    route: '/core-hcm',
    children: [
      {
        displayName: 'Postulantes',
        iconName: 'tabler:point',
        route: '/core-hcm/personas',
        permission: { modulo: 'CORE_HCM', subModulo: 'POSTULANTES' },
      },
    ],
  },
  {
    displayName: 'Trabajador',
    iconName: 'solar:user-id-line-duotone',
    permiso: 'TRABAJADOR',
    route: '/trabajadores',
    children: [
      { displayName: 'Gestión de Trabajadores', iconName: 'tabler:point', route: '/trabajadores/gestion-trabajadores', permission: { modulo: 'TRABAJADOR', subModulo: 'GESTION_TRABAJADORES' } },
      { displayName: 'Derechohabientes', iconName: 'tabler:point', route: '/trabajadores/derecho-habientes', permission: { modulo: 'TRABAJADOR', subModulo: 'DERECHO_HABIENTES' } },
      { displayName: 'Control de Asistencia', iconName: 'tabler:point', route: '/trabajadores/control-asistencia', permission: { modulo: 'TRABAJADOR', subModulo: 'CONTROL_ASISTENCIA' } },
      { displayName: 'Horas Extras', iconName: 'tabler:point', route: '/trabajadores/horas-extras', permission: { modulo: 'TRABAJADOR', subModulo: 'HORAS_EXTRAS' } },
      { displayName: 'Solicitudes', iconName: 'tabler:point', route: '/trabajadores/solicitudes', permission: { modulo: 'TRABAJADOR', subModulo: 'SOLICITUDES' } },
      { displayName: 'Vacaciones', iconName: 'tabler:point', route: '/trabajadores/vacaciones', permission: { modulo: 'TRABAJADOR', subModulo: 'VACACIONES' } },
      { displayName: 'Capacitaciones', iconName: 'tabler:point', route: '/trabajadores/capacitaciones', permission: { modulo: 'TRABAJADOR', subModulo: 'CAPACITACIONES' } },
      { displayName: 'Encuestas', iconName: 'tabler:point', route: '/trabajadores/encuestas', permission: { modulo: 'TRABAJADOR', subModulo: 'ENCUESTAS' } },
      { displayName: 'Compromisos', iconName: 'tabler:point', route: '/trabajadores/compromisos', permission: { modulo: 'TRABAJADOR', subModulo: 'COMPROMISOS' } },
    ],
  },
  {
    displayName: 'Planilla',
    iconName: 'solar:document-text-line-duotone',
    permiso: 'PLANILLA',
    route: '/planilla',
    children: [
      { displayName: 'Gestión de dependientes e independientes', iconName: 'tabler:point', route: '/planilla/generar-planilla', permission: { modulo: 'PLANILLA', subModulo: 'GESTION_DEPENDIENTES' } },
      { displayName: 'Adelanto de sueldo', iconName: 'tabler:point', route: '/planilla/adelanto-sueldo', permission: { modulo: 'PLANILLA', subModulo: 'ADELANTO_SUELDO' } },
      { displayName: 'Control de Pagos', iconName: 'tabler:point', route: '/planilla/control-pagos', permission: { modulo: 'PLANILLA', subModulo: 'CONTROL_PAGOS' } },
      { displayName: 'Préstamos', iconName: 'tabler:point', route: '/planilla/prestamos', permission: { modulo: 'PLANILLA', subModulo: 'PRESTAMOS' } },
      { displayName: 'AFP Net', iconName: 'tabler:point', route: '/planilla/afp-net', permission: { modulo: 'PLANILLA', subModulo: 'AFP_NET' } },
      { displayName: 'Cálculos', iconName: 'tabler:point', route: '/planilla/calculos', permission: { modulo: 'PLANILLA', subModulo: 'CALCULOS' } },
      { displayName: 'Renta 5ta', iconName: 'solar:document-text-bold-duotone', route: '/planilla/renta-5ta', permission: { modulo: 'PLANILLA', subModulo: 'RENTA_5TA' } },
    ],
  },
  {
    displayName: 'Contabilidad',
    iconName: 'solar:calculator-line-duotone',
    permiso: 'CONTABILIDAD',
    route: '/contabilidad',
    children: [
      { displayName: 'Mantenimiento Conceptos', iconName: 'tabler:point', route: '/contabilidad/mantenimiento-conceptos', permission: { modulo: 'CONTABILIDAD', subModulo: 'MANTENIMIENTO_CONCEPTOS' } },
      { displayName: 'Asiento Planilla', iconName: 'tabler:point', route: '/contabilidad/asiento-planilla', permission: { modulo: 'CONTABILIDAD', subModulo: 'ASIENTO_PLANILLA' } },
    ],
  },
  {
    displayName: 'Equipo',
    iconName: 'solar:case-round-line-duotone',
    permiso: 'EQUIPO',
    route: '/equipo',
    children: [
      {
        displayName: 'Reclutamiento',
        iconName: 'solar:buildings-2-line-duotone',
        route: '/equipo/reclutamiento',
        permission: { modulo: 'EQUIPO', subModulo: 'RECLUTAMIENTO' },
      },
      {
        displayName: 'Gestión de equipo',
        iconName: 'solar:buildings-2-line-duotone',
        route: '/equipo/gestion-equipo',
        permission: { modulo: 'EQUIPO', subModulo: 'GESTION_EQUIPO' },
      },
    ],
  },
  {
    displayName: 'Configuración global',
    iconName: 'solar:settings-bold-duotone',
    permiso: 'CONFIGURACION_GLOBAL',
    route: '/configuracion-global',
    children: [
      { displayName: 'Empresa', iconName: 'solar:buildings-2-line-duotone', route: '/configuracion-global/empresas', permission: { modulo: 'CONFIGURACION_GLOBAL', subModulo: 'EMPRESAS' } },
      { displayName: 'Departamento Empresa', iconName: 'solar:buildings-2-line-duotone', route: '/configuracion-global/departamento-empresa', permission: { modulo: 'CONFIGURACION_GLOBAL', subModulo: 'DEPARTAMENTO_EMPRESA' } },
      { displayName: 'Área Empresa', iconName: 'solar:case-round-line-duotone', route: '/configuracion-global/area-empresa', permission: { modulo: 'CONFIGURACION_GLOBAL', subModulo: 'AREA_EMPRESA' } },
      { displayName: 'Puestos', iconName: 'solar:case-minimalistic-line-duotone', route: '/configuracion-global/puestos', permission: { modulo: 'CONFIGURACION_GLOBAL', subModulo: 'PUESTOS' } },
      { displayName: 'Parámetro Global', iconName: 'solar:settings-bold-duotone', route: '/configuracion-global/parametros-globales', permission: { modulo: 'CONFIGURACION_GLOBAL', subModulo: 'PARAMETROS_GLOBALES' } },
    ],
  },
  {
  displayName: 'Configuración',
  iconName: 'solar:settings-line-duotone',
  permiso: 'CONFIGURACION',
  route: '/configuracion',
  children: [
    { displayName: 'Gestión Pensión', iconName: 'solar:wallet-money-line-duotone', route: '/configuracion/datos-afp-onp', permission: { modulo: 'CONFIGURACION', subModulo: 'GESTION_PENSION' } },
    { displayName: 'Centro Costos', iconName: 'solar:case-round-line-duotone', route: '/configuracion/centro-costos', permission: { modulo: 'CONFIGURACION', subModulo: 'CENTRO_COSTOS' } },
    { displayName: 'Establecimientos', iconName: 'solar:buildings-3-line-duotone', route: '/configuracion/establecimientos', permission: { modulo: 'CONFIGURACION', subModulo: 'ESTABLECIMIENTOS' } },
    { displayName: 'Escalas Salariales', iconName: 'solar:money-bag-line-duotone', route: '/configuracion/escalas-salariales', permission: { modulo: 'CONFIGURACION', subModulo: 'ESCALAS_SALARIALES' } },
    {
      displayName: 'Tiempo y periodos',
      iconName: 'solar:calendar-line-duotone',
      route: '/configuracion/tiempo-periodos',
      permission: { modulo: 'CONFIGURACION', subModulo: 'HORARIOS_TURNOS' },
      children: [
        { displayName: 'Turnos', iconName: 'tabler:point', route: '/configuracion/tiempo-periodos/turnos', permission: { modulo: 'CONFIGURACION', subModulo: 'HORARIOS_TURNOS' } },
        { displayName: 'Horarios', iconName: 'tabler:point', route: '/configuracion/tiempo-periodos/horarios', permission: { modulo: 'CONFIGURACION', subModulo: 'HORARIOS_TURNOS' } },
      ],
    },
  ],
},
  {
    displayName: 'Sistema',
    iconName: 'solar:settings-minimalistic-line-duotone',
    permiso: 'SISTEMA',
    route: '/sistema',
    children: [
      { displayName: 'pages.sistema.cards.monedas.title', iconName: 'solar:translate-line-duotone', route: '/sistema/monedas' },
      { displayName: 'pages.sistema.cards.paises.title', iconName: 'solar:wallet-money-line-duotone', route: '/sistema/paises' },
      { displayName: 'pages.sistema.cards.bancos.title', iconName: 'solar:case-round-line-duotone', route: '/sistema/bancos' },
      { displayName: 'pages.sistema.cards.tipoCuentaBancaria.title', iconName: 'solar:buildings-3-line-duotone', route: '/sistema/tipo-cuenta-bancaria' },
      { displayName: 'pages.sistema.cards.cuentasBancarias.title', iconName: 'solar:money-bag-line-duotone', route: '/sistema/cuentas-bancarias' },
 ],
  },
  {
    displayName: 'Organigrama',
    iconName: 'solar:users-group-rounded-line-duotone',
    permiso: 'ORGANIGRAMA',
    children: [
      { displayName: 'Ver Organigrama', iconName: 'tabler:point', route: '/organigrama' },
    ],
  },
  {
    displayName: 'Personas',
    iconName: 'solar:users-group-two-rounded-line-duotone',
    permiso: 'PERSONAS',
    route: '/personas',
    children: [
      { displayName: 'Transferencias', iconName: 'tabler:point', route: '/personas/transferencias', permission: { modulo: 'PERSONAS', subModulo: 'TRANSFERENCIAS' } },
    ],
  },
  {
    displayName: 'Reportes y BI',
    iconName: 'solar:chart-line-duotone',
    permiso: 'REPORTES_BI',
    route: '/reportes-bi',
    children: [
      { displayName: 'Reportes legales', iconName: 'tabler:point', route: '/reportes-bi/reportes-legales' },
      { displayName: 'Exportaciones', iconName: 'tabler:point', route: '/reportes-bi/exportaciones' },
    ],
  },
  {
    displayName: 'Gestión del Desempeño',
    iconName: 'solar:target-line-duotone',
    permiso: 'GESTION_DESEMPENO',
    route: '/trabajadores/gestion-desempeno-objetivos',
    children: [
      { displayName: 'Objetivos', iconName: 'tabler:point', route: '/trabajadores/gestion-desempeno-objetivos/objetivos', permission: { modulo: 'GESTION_DESEMPENO', subModulo: 'OBJETIVOS' } },
      { displayName: 'Desempeño', iconName: 'tabler:point', route: '/trabajadores/gestion-desempeno', permission: { modulo: 'GESTION_DESEMPENO', subModulo: 'DESEMPENO' } },
    ],
  },
];

  /*
  {
    navCap: 'Contabilidad',
  },
  {
    displayName: 'Icons',
    iconName: 'solar:sticker-smile-circle-2-line-duotone',
    route: '/extra/icons',
  },
  {
    displayName: 'Sample Page',
    iconName: 'solar:planet-3-line-duotone',
    route: '/extra/sample-page',
  },
  {
    navCap: 'Home',
  },
  {
    displayName: 'Modern',
    iconName: 'solar:widget-line-duotone',
    route: 'https://angular.tailwind-admin.com/dashboards/dashboard1',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },

  {
    displayName: 'eCommerce',
    iconName: 'solar:cart-line-duotone',
    route: 'https://angular.tailwind-admin.com/dashboards/dashboard2',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Music',
    iconName: 'solar:music-note-line-duotone',
    route: 'https://angular.tailwind-admin.com/dashboards/dashboard3',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'General',
    iconName: 'solar:chart-line-duotone',
    route: 'https://angular.tailwind-admin.com/dashboards/dashboard4',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Frontend pages',
    iconName: 'solar:home-angle-line-duotone',
    route: 'front-pages',
    children: [
      {
        displayName: 'Home Page',
        iconName: 'tabler:point',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
        route: 'https://angular.tailwind-admin.com/front-pages/homepage',
      },
      {
        displayName: 'About Us',
        iconName: 'tabler:point',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
        route: 'https://angular.tailwind-admin.com/front-pages/about',
      },
      {
        displayName: 'Blog',
        iconName: 'tabler:point',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
        route: 'https://angular.tailwind-admin.com/front-pages/blog',
      },
      {
        displayName: 'Blog Details',
        iconName: 'tabler:point',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
        route: 'https://angular.tailwind-admin.com/front-pages/blog-details',
      },
      {
        displayName: 'Portfolio',
        iconName: 'tabler:point',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
        route: 'https://angular.tailwind-admin.com/front-pages/portfolio',
      },
      {
        displayName: 'Pricing',
        iconName: 'tabler:point',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
        route: 'https://angular.tailwind-admin.com/front-pages/pricing',
      },
      {
        displayName: 'Contact',
        iconName: 'tabler:point',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
        route: 'https://angular.tailwind-admin.com/front-pages/contact',
      }
    ]
  },

  {
    navCap: 'Modules',
  },
  {
    displayName: 'Expansion Panel',
    iconName: 'solar:inbox-archive-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/expansion',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Dialog',
    iconName: 'solar:bolt-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/dialog',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Divider',
    iconName: 'solar:menu-dots-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/divider',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Paginator',
    iconName: 'solar:tuning-2-bold-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/paginator',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Progress Bar',
    iconName: 'solar:restart-bold-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/progress',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Progress Spinner',
    iconName: 'solar:refresh-circle-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/progress-spinner',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Ripples',
    iconName: 'solar:branching-paths-up-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/ripples',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Slide Toggle',
    iconName: 'solar:round-alt-arrow-right-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/slide-toggle',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Slider',
    iconName: 'solar:tuning-3-bold-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/slider',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Snackbar',
    iconName: 'solar:layers-minimalistic-bold-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/snackbar',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Tabs',
    iconName: 'solar:box-minimalistic-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/tabs',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Toolbar',
    iconName: 'solar:balloon-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/toolbar',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Tooltips',
    iconName: 'solar:feed-line-duotone',
    route: 'https://angular.tailwind-admin.com/ui-components/tooltips',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },

  {
    navCap: 'Apps',
  },
  {
    displayName: 'Chat',
    iconName: 'solar:chat-round-line-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/chat',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Calendar',
    iconName: 'solar:calendar-mark-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/calendar',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Email',
    iconName: 'solar:letter-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/email/inbox',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Kanban',
    iconName: 'solar:clapperboard-edit-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/kanban',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Contacts',
    iconName: 'solar:phone-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/contacts',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'ContactsApp',
    iconName: 'solar:phone-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/contact-list',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Courses',
    iconName: 'solar:book-bookmark-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/courses',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Employee',
    iconName: 'solar:user-id-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/employee',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Notes',
    iconName: 'solar:document-text-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/notes',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Tickets',
    iconName: 'solar:ticket-sale-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/tickets',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'ToDo',
    iconName: 'solar:airbuds-case-minimalistic-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/todo',
    chip: true,
    external: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Invoice',
    iconName: 'solar:bill-list-line-duotone',
    route: '',
    chip: true,

    children: [
      {
        displayName: 'List',
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/apps/invoice',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Detail',
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/apps/viewInvoice/101',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Create',
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/apps/addInvoice',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Edit',
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/apps/editinvoice/101',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },
  {
    displayName: 'Blog',
    iconName: 'solar:widget-4-line-duotone',
    route: 'apps/blog',
    chip: true,

    children: [
      {
        displayName: 'Post',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/apps/blog/post',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Detail',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/apps/blog/detail/Early Black Friday Amazon deals: cheap TVs, headphones, laptops',
        chip: true,
        external: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },

  {
    navCap: 'Pages',
  },
  {
    displayName: 'Roll Base Access',
    iconName: 'solar:lock-password-unlocked-line-duotone',
    route: 'https://angular.tailwind-admin.com/apps/permission',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Treeview',
    iconName: 'solar:bill-line-duotone',
    route: 'https://angular.tailwind-admin.com/theme-pages/treeview',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Pricing',
    iconName: 'solar:dollar-minimalistic-line-duotone',
    route: 'https://angular.tailwind-admin.com/theme-pages/pricing',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Account Setting',
    iconName: 'solar:accessibility-line-duotone',
    route: 'https://angular.tailwind-admin.com/theme-pages/account-setting',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'FAQ',
    iconName: 'solar:question-square-line-duotone',
    route: 'https://angular.tailwind-admin.com/theme-pages/faq',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Landingpage',
    iconName: 'solar:layers-minimalistic-line-duotone',
    route: 'https://angular.tailwind-admin.com/landingpage',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Widgets',
    iconName: 'solar:widget-2-line-duotone',
    route: 'widgets',
    chip: true,

    children: [
      {
        displayName: 'Cards',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/widgets/cards',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Banners',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/widgets/banners',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Charts',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/widgets/charts',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },

  {
    navCap: 'Forms',
  },
  {
    displayName: 'Form elements',
    iconName: 'solar:password-minimalistic-input-line-duotone',
    route: 'forms/forms-elements',
    chip: true,

    children: [
      {
        displayName: 'Autocomplete',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/forms/forms-elements/autocomplete',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Button',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/forms/forms-elements/button',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Checkbox',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/forms/forms-elements/checkbox',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Radio',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/forms/forms-elements/radio',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Datepicker',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/forms/forms-elements/datepicker',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },
  {
    displayName: 'Form Layouts',
    iconName: 'solar:file-text-line-duotone',
    route: 'https://angular.tailwind-admin.com/forms/form-layouts',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Form Horizontal',
    iconName: 'solar:align-horizonta-spacing-line-duotone',
    route: 'https://angular.tailwind-admin.com/forms/form-horizontal',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Form Vertical',
    iconName: 'solar:align-vertical-spacing-line-duotone',
    route: 'https://angular.tailwind-admin.com/forms/form-vertical',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Form Wizard',
    iconName: 'solar:archive-minimalistic-line-duotone',
    route: 'https://angular.tailwind-admin.com/forms/form-wizard',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Toastr',
    iconName: 'solar:notification-lines-remove-line-duotone',
    route: 'https://angular.tailwind-admin.com/forms/form-toastr',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },

  {
    navCap: 'Tables',
  },
  {
    displayName: 'Tables',
    iconName: 'solar:tablet-line-duotone',
    route: 'tables',
    chip: true,

    children: [
      {
        displayName: 'Basic Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/basic-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Dynamic Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/dynamic-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Expand Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/expand-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Filterable Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/filterable-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Footer Row Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/footer-row-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'HTTP Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/http-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Mix Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/mix-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Multi Header Footer',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/multi-header-footer-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Pagination Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/pagination-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Row Context Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/row-context-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Selection Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/selection-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Sortable Table',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/sortable-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Sticky Column',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/sticky-column-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Sticky Header Footer',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/tables/sticky-header-footer-table',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },
  {
    displayName: 'Data table',
    iconName: 'solar:database-line-duotone',
    route: 'https://angular.tailwind-admin.com/datatable/kichen-sink',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },

  {
    navCap: 'Chart',
  },
  {
    displayName: 'Line',
    iconName: 'solar:align-top-line-duotone',
    route: 'https://angular.tailwind-admin.com/charts/line',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Gredient',
    iconName: 'solar:bolt-circle-line-duotone',
    route: 'https://angular.tailwind-admin.com/charts/gredient',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Area',
    iconName: 'solar:chart-square-line-duotone',
    route: 'https://angular.tailwind-admin.com/charts/area',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Candlestick',
    iconName: 'solar:align-left-line-duotone',
    route: 'https://angular.tailwind-admin.com/charts/candlestick',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Column',
    iconName: 'solar:chart-2-line-duotone',
    route: 'https://angular.tailwind-admin.com/charts/column',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Doughnut & Pie',
    iconName: 'solar:pie-chart-2-line-duotone',
    route: 'https://angular.tailwind-admin.com/charts/doughnut-pie',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Radialbar & Radar',
    iconName: 'solar:align-vertical-center-line-duotone',
    route: 'https://angular.tailwind-admin.com/charts/radial-radar',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },

  {
    navCap: 'Auth',
  },
  {
    displayName: 'Login',
    iconName: 'solar:lock-keyhole-minimalistic-line-duotone',
    route: '/authentication',
    children: [
      {
        displayName: 'Side Login',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/authentication/login',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },
  {
    displayName: 'Register',
    iconName: 'solar:user-plus-rounded-line-duotone',
    route: '/authentication',
    children: [
      {
        displayName: 'Side Register',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/authentication/side-register',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },
  {
    displayName: 'Forgot Pwd',
    iconName: 'solar:password-outline',
    route: '/authentication',
    chip: true,

    children: [
      {
        displayName: 'Side Forgot Pwd',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/authentication/side-forgot-pwd',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Boxed Forgot Pwd',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/authentication/boxed-forgot-pwd',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },
  {
    displayName: 'Two Steps',
    iconName: 'solar:siderbar-line-duotone',
    route: '/authentication',
    chip: true,

    children: [
      {
        displayName: 'Side Two Steps',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/authentication/side-two-steps',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
      {
        displayName: 'Boxed Two Steps',
        subItemIcon: true,
        iconName: 'solar:round-alt-arrow-right-line-duotone',
        route: 'https://angular.tailwind-admin.com/authentication/boxed-two-steps',
        external: true,
        chip: true,
        chipClass: 'bg-light-secondary text-secondary',
        chipContent: 'Pro',
      },
    ],
  },
  {
    displayName: 'Error',
    iconName: 'solar:bug-minimalistic-line-duotone',
    route: 'https://angular.tailwind-admin.com/authentication/error',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  },
  {
    displayName: 'Maintenance',
    iconName: 'solar:settings-line-duotone',
    route: 'https://angular.tailwind-admin.com/authentication/maintenance',
    external: true,
    chip: true,
    chipClass: 'bg-light-secondary text-secondary',
    chipContent: 'Pro',
  }, */


